import { html } from 'fxjs/es';
import { ButtonAction } from '../../../../../services/MarppleShop/shared/components/atoms/ButtonAction/ButtonAction.ts';
import { typo } from '../../../../../services/MarppleShop/shared/typography/typo.js';
import { UtilImageS } from '../../../../Util/Image/S/Function/module/UtilImageS.js';

export const emptyPlusPage = (p) => html`
  <div class="empty_plus_page">
    <div class="icon">
      <img
        src="//s3.marpple.co/files/u_218933/2020/6/original/1871633f4e52889790133f282e959e244d3117c3c7b5674.png"
        alt=""
      />
    </div>
    <p>${p}</p>
  </div>
`;

export const makeEmptyPlusContentsPage = () => {
  const component = 'empty_plus_contents_page';
  return html`
    <div class="${component}">
      <div class="${component}__container">
        <img
          class="${component}__image"
          src="${UtilImageS.getResizedUrl({
            format: 'webp',
            url: 'https://s3.marpple.co/files/u_1165777/2024/6/original/6379f6492c34a8020be67811eb049dd05d33711a1.png',
          })}"
          alt=""
        />
        <div>
          <h3 class="${component}__title ${typo('20_bold')}">${ET('mps2::plus::ready_for_contents')}</h3>
          <p class="${component}__description ${typo('16_medium')}">
            ${ET('mps2::plus::see_products_waiting_contents')}
          </p>
        </div>

        ${new ButtonAction({
          href: `/${ET.lang}/@/products`,
          fit: true,
          size: 'large',
          label: ET('mps2::plus::see_products'),
          type: 'blue',
        }).toHtml()}
      </div>
    </div>
  `;
};
